import * as React from "react";
const SvgSolid = props => <svg xmlns="http://www.w3.org/2000/svg" width={28} height={28} {...props}><path stroke="currentColor" d="M4 13.5h20" /></svg>;
export default SvgSolid;